/**
 * "Save your recovery codes." (design: ob-entry.jsx ScreenRecovery) — the
 * kit's RecoveryCodes with the page frame around it. Continue stays disabled
 * until "I've saved these codes" is ticked.
 */
import { useState } from "react";
import { ObMain, ObShell, RecoveryCodes } from "../kit";
import { InviteeTopBar } from "./common";

export function RecoveryScreen({
  codes,
  account,
  orgName,
  personName,
  onContinue,
}: {
  codes: string[];
  account: string;
  orgName: string;
  personName?: string | null;
  onContinue: () => void;
}) {
  const [saved, setSaved] = useState(false);
  return (
    <ObShell>
      <InviteeTopBar orgName={orgName} personName={personName} />
      <ObMain width={680} data-screen-label="Recovery codes">
        <RecoveryCodes codes={codes} saved={saved} onSaved={setSaved} account={account} onContinue={onContinue} />
      </ObMain>
    </ObShell>
  );
}
